module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "exe"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/frontmatter002#exe"
    }
  }, [_vm._v("List of Excursuses")])]), _vm._v(" "), _c('p', {
    staticClass: "Toca",
    attrs: {
      "id": "pre1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface001#pre1"
    }
  }, [_vm._v("Editor’s Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "Toca",
    attrs: {
      "id": "pre2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface002#pre2"
    }
  }, [_vm._v("Author’s Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "Toca",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/abbreviations#abb"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "Toca",
    attrs: {
      "id": "bib"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/bibliography#bib"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch1s1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s1"
    }
  }, [_vm._v("Introductory Matters Related to 1–3 John")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s2"
    }
  }, [_vm._v("A Scenario")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s3"
    }
  }, [_vm._v("The Johannine Community")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s4"
    }
  }, [_vm._v("1–3 John and the Fourth Gospel")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s5"
    }
  }, [_vm._v("The Interrelationship of 1–3 John")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s6"
    }
  }, [_vm._v("1–3 John and the NT Canon")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch1s7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s7"
    }
  }, [_vm._v("Introductory Matters Related to 1 John")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s8"
    }
  }, [_vm._v("Authorship")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch1s9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s9"
    }
  }, [_vm._v("Internal Evidence")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch1s10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s10"
    }
  }, [_vm._v("External Evidence")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s11"
    }
  }, [_vm._v("Addressees")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s12"
    }
  }, [_vm._v("Opponents")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch1s13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s13"
    }
  }, [_vm._v("The Teaching of the Secessionists")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch1s14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s14"
    }
  }, [_vm._v("The Secessionists and the Author’s Community")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch1s15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s15"
    }
  }, [_vm._v("The Secessionists and Early Christian Heretics")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s16"
    }
  }, [_vm._v("Purpose and Time of Writing")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s17"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s17"
    }
  }, [_vm._v("Genre, Rhetorical Form, and Structure")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch1s18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s18"
    }
  }, [_vm._v("Genre")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch1s19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s19"
    }
  }, [_vm._v("Rhetorical Form")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch1s20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s20"
    }
  }, [_vm._v("Structure")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s21"
    }
  }, [_vm._v("1 John and Qumran")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s22"
    }
  }, [_vm._v("Major Theological Themes")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch1s23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s23"
    }
  }, [_vm._v("What the Author Affirmed While Rejecting Secessionist Teaching")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch1s24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s24"
    }
  }, [_vm._v("What the Author Affirmed While Reassuring His Readers")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch1s25"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s25"
    }
  }, [_vm._v("Important Matters the Author Taught along the Way")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch1s26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s26"
    }
  }, [_vm._v("Introductory Matters Related to 2 John")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s27"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s27"
    }
  }, [_vm._v("Authorship")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s28"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s28"
    }
  }, [_vm._v("Addressees")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s29"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s29"
    }
  }, [_vm._v("Opponents")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s30"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s30"
    }
  }, [_vm._v("Purpose and Time of Writing")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s31"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s31"
    }
  }, [_vm._v("Genre, Rhetorical Form, and Structure")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s32"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s32"
    }
  }, [_vm._v("Major Theological Themes")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch1s33"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s33"
    }
  }, [_vm._v("Introductory Matters Related to 3 John")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s34"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s34"
    }
  }, [_vm._v("Authorship")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s35"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s35"
    }
  }, [_vm._v("Addressee")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s36"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s36"
    }
  }, [_vm._v("Itinerant Missionaries")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s37"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s37"
    }
  }, [_vm._v("Diotrephes and the Elder")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s38"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s38"
    }
  }, [_vm._v("Purpose and Time of Writing")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s39"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s39"
    }
  }, [_vm._v("Genre, Rhetorical Form, and Structure")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s40"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s40"
    }
  }, [_vm._v("Major Theological Themes")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part001#pt001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 JOHN")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OUTLINE OF 1 JOHN")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COMMENTARY ON 1 JOHN")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch3s1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Preface Concerning the Word of Life (1:1–4)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch3s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Claims to Know God Tested by Attitudes to Sin (1:5–2:2)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch3s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Claims to Know God Tested by Obedience (2:3–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch3s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Affirmation and Exhortation for Believers (2:12–17)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch3s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003a#s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Warnings against Being Deceived by the Secessionists (2:18–27)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch3s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003a#s6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Distinguishing the Children of God from the Children of the Devil (2:28–3:10)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch3s7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003a#s7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Gospel Demand to Love One Another and Confidence in Prayer (3:11–24)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch3s8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003a#s8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Testing the “Spirits” (4:1–6)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch3s9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003a#s9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Claims to Love God Tested by Love for Fellow Believers (4:7–5:4a)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch3s10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003b#s10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Accepting God’s Testimony and Eternal Life (5:4b–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch3s11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003b#s11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Concluding Reassurances and Exhortations (5:13–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part002#pt002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 JOHN")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OUTLINE OF 2 JOHN")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ch005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COMMENTARY ON 2 JOHN")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch5s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Opening Greetings (1–3)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch5s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Walking in the Truth (4–6)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch5s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Denial of the Truth (7–9)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch5s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Do Not Receive Those Who Deny the Truth (10–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch5s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Final Greetings (12–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-003"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/part003#pt003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 JOHN")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OUTLINE OF 3 JOHN")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#ch007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COMMENTARY ON 3 JOHN")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch7s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Opening Greetings (1)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch7s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rejoicing That Gaius Walks in the Truth (2–4)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch7s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gaius Commended for His Hospitality (5–8)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch7s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Diotrephes’s Opposition to the Elder (9–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch7s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Elder’s Commendation of Demetrius (11–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch7s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Final Greetings (13–14)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc4",
    attrs: {
      "id": "app"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix#app",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX: BIBLICAL AND EXTRABIBLICAL REFERENCES TO CAIN")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEXES")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "idx-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index001#idx001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I."), _c('span', {
    staticClass: "space2"
  }, [_vm._v("Subjects")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "idx-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index002#idx002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II."), _c('span', {
    staticClass: "spacee"
  }, [_vm._v("Modern Authors")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "idx-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index003#idx003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III."), _c('span', {
    staticClass: "space05"
  }, [_vm._v("Scripture References")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "idx-004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index004#idx004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Extrabiblical Literature")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0